import React from 'react'
import { Authenticator } from '@aws-amplify/ui-react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from "../components/CheckoutForm";

const Checkout = () => {
    const stripePromise = loadStripe('pk_test_51Km3koIUVWbwbC6NJ8LlnhxFO3GDXmWEdk1MIQLXCLQH9rO0Orw79b6LyjTKviTf6utr7zSmPwUeqPgPpoY1zwpC00ttlHJDNF');

    return (
        <section className="checkout-wrapper">
            <Authenticator>
                <Elements stripe={stripePromise}>
                    <section>
                        <h2>Time to Checkout?</h2>
                        <CheckoutForm />
                    </section>
                </Elements>
            </Authenticator>
        </section>
    )
}

export default Checkout
